import {
  List,
  SimpleForm,
  Button as ButtonR,
  TextInput,
  Datagrid,
  Edit,
  Create,
  TextField,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  useRefresh,
  useNotify,
  useDataProvider,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import { EmptyActions, CustomToolbar, ExtraPagination } from './utils'
import Chip from '@material-ui/core/Chip'
import DeleteIcon from '@mui/icons-material/Delete'

export const RoutingKeywordCreate = (props) => {
  return (
    <Create {...props}>
      <SimpleForm variant="outlined">
        <ReferenceInput
          label="Tag"
          source="tag_id"
          reference="front_tags"
          variant="outlined"
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
        <TextInput source="keyword" label="Keyword" />
      </SimpleForm>
    </Create>
  )
}

const DeleteButton = ({ record }) => {
  const refresh = useRefresh()
  const notify = useNotify()
  const dataProvider = useDataProvider()

  const func = () =>
    dataProvider
      .delete('routing_keywords', { id: record.id })
      .then((response) => {
        notify('Succès')
        refresh()
      })
      .catch((error) => {
        notify(`${error.message}`, 'warning')
      })
  return (
    <ButtonR label="" onClick={func}>
      <DeleteIcon />
    </ButtonR>
  )
}

export const RoutingKeywordsList = (props) => (
  <List
    bulkActionButtons={false}
    exporter={false}
    pagination={<ExtraPagination />}
    {...props}
  >
    <Datagrid rowClick={false}>
      <TextField source="tag" label="Tag" />
      <TextField source="keyword" label="Keyword" />
      <DeleteButton />
    </Datagrid>
  </List>
)
